import { createForm } from '../../../foundation/forms';
import { FIELD } from '../../../constants/formConstants';

const enrollFields = [
  {
    type: FIELD.TYPE.CHECKBOXGROUP,
    name: 'salesAgreementNumbers',
    defaultValue: []
  }
];

const EnrollFormManager = {
  createForm: () => {
    const form = createForm(enrollFields);
    return form;
  }
};

export default EnrollFormManager;
